import { formatData as formatOldButtonData } from "../../../../features/button-inline/oldButtonService";
import { handleCountdownMigration } from "../../../../features/countdown/migration";
import { MACRO_KEY } from "../../../defaults";

export const migrateColor = (value) => {
  let color;

  try {
    color = JSON.parse(value);
  } catch {
    color = { light: value, dark: value };
  }

  return color;
};

export const parseJSON = (value) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    return {};
  }
};

const cards = (data) => data.data;
const buttonBlock = (data) => ({
  ...data,
  icon: parseJSON(data.icon),
  url: parseJSON(data.url),
  accentColor: parseJSON(data.accentColor),
  backgroundColor: parseJSON(data.backgroundColor),
  border: parseJSON(data.border),
  labelColor: parseJSON(data.labelColor),
});
const buttonInline = (data) => {
  const isOldButton = !data?.macro;
  if (isOldButton) {
    return {
      isOldButton,
      ...formatOldButtonData(data),
    };
  }
  return {
    ...data,
    icon: parseJSON(data.icon),
    url: parseJSON(data.url),
    accentColor: parseJSON(data.accentColor),
    backgroundColor: parseJSON(data.backgroundColor),
    border: parseJSON(data.border),
    labelColor: parseJSON(data.labelColor),
  };
};
const spacerAndDivider = (data) => ({
  ...data,
  emoji: parseJSON(data.emoji),
  color: migrateColor(data.color),
  textColor: migrateColor(data.textColor),
  iconColor: migrateColor(data.iconColor),
});
const panelSimple = (data) => ({
  ...data,
  icon: data.icon ? parseJSON(data.icon) : undefined,
  alignment: data.alignment ? parseJSON(data.alignment) : undefined,
  accentColor: parseJSON(data.accentColor),
  textColor: parseJSON(data.textColor),
  displayElements: parseJSON(data.displayElements),
});
const panelAdvanced = (data) => parseJSON(data.data);
const announcements = (data) => parseJSON(data.data);
const imageSlider = (data) => parseJSON(data.data);
const advancedTabsGroup = (data) => parseJSON(data.data);
const advancedTabsSingle = (data) => parseJSON(data.data);
const countdown = (data) => handleCountdownMigration(data);
const titleAndText = (data) => ({
  ...data,
  emoji: parseJSON(data?.emoji || "{}"),
  layout: parseJSON(data?.layout || "{}"),
  colorsByColorScheme: parseJSON(data?.colorsByColorScheme || "{}"),
});
const footnoteDisplay = (data) => ({
  ...data,
  titleStyle: String(data.titleStyle),
});
const tooltipsFootnotes = (data) => ({
  ...data,
  color: migrateColor(data.color),
  textColor: parseJSON(data.textColor || "{ light: '#fff', dark: '#fff' }"),
});
const html = (data) => ({
  ...data,
  theme: parseJSON(data.theme),
  contentByMode: parseJSON(data.contentByMode),
  mode: data.mode || "html",
});

const handlers = {
  [MACRO_KEY.CARDS]: cards,
  [MACRO_KEY.BUTTON]: buttonBlock,
  [MACRO_KEY.BUTTON_INLINE]: buttonInline,
  [MACRO_KEY.SPACER_AND_DIVIDER]: spacerAndDivider,
  [MACRO_KEY.PANEL_SIMPLE]: panelSimple,
  [MACRO_KEY.PANEL_ADVANCED]: panelAdvanced,
  [MACRO_KEY.ANNOUNCEMENTS]: announcements,
  [MACRO_KEY.IMAGE_SLIDER]: imageSlider,
  [MACRO_KEY.ADVANCED_TABS_GROUP]: advancedTabsGroup,
  [MACRO_KEY.ADVANCED_TABS_SINGLE]: advancedTabsSingle,
  [MACRO_KEY.COUNTDOWN]: countdown,
  [MACRO_KEY.TEXT_AND_TITLE]: titleAndText,
  [MACRO_KEY.FOOTNOTE_DISPLAY]: footnoteDisplay,
  [MACRO_KEY.TOOLTIPS_AND_FOOTNOTES]: tooltipsFootnotes,
  [MACRO_KEY.HTML]: html,
};

const MACROS_TO_IGNORE = [
  MACRO_KEY.HTML,
  MACRO_KEY.TOOLTIPS_AND_FOOTNOTES,
  MACRO_KEY.FOOTNOTE_DISPLAY,
];

export const handleStoredData = (macro, data) => {
  const isOldMacro = !data?.macro && !MACROS_TO_IGNORE.includes(macro);
  const handler = handlers[macro];
  if (handler) {
    return { content: handler(data), isOldMacro };
  }
  return { content: undefined, isOldMacro: false };
};
